import { defineStore } from 'pinia';

export const useUserJourneyStore = defineStore(
  'ap.userJourney',
  () => {
    const user = reactive<User>({});
    const device = reactive<Device>({});
    const utm = reactive<Utm>({});
    const google = reactive<GoogleAttribution>({});
    const facebook = reactive<FacebookAttribution>({});
    const tiktok = reactive<TiktokAttribution>({});
    const apt = reactive<AptAttribution>({});

    function setUser(newUser: User) {
      user.id = newUser.id;
    }

    function setDevice(newDevice: Device) {
      device.fingerprint = newDevice.fingerprint;
    }

    function setUtm(newUtm: Utm) {
      utm.source = newUtm.source;
      utm.medium = newUtm.medium;
      utm.campaign = newUtm.campaign;
      utm.id = newUtm.id;
      utm.term = newUtm.term;
      utm.content = newUtm.content;
    }

    function setGoogle(newGoogle: GoogleAttribution) {
      google.gclid = newGoogle.gclid;
      google.gbraid = newGoogle.gbraid;
      google.wbraid = newGoogle.wbraid;
    }

    function setFacebook(newFacebook: FacebookAttribution) {
      facebook.fbclid = newFacebook.fbclid;
      facebook.fbc = newFacebook.fbc;
      facebook.fbp = newFacebook.fbp;
    }

    function setTiktok(newTiktok: TiktokAttribution) {
      tiktok.ttclid = newTiktok.ttclid;
    }

    function setApt(newApt: AptAttribution) {
      apt.channel = newApt.channel;
      apt.content = newApt.content;
      apt.extra = newApt.extra;
    }

    return {
      user,
      setUser,
      device,
      setDevice,
      utm,
      setUtm,
      google,
      setGoogle,
      facebook,
      setFacebook,
      tiktok,
      setTiktok,
      apt,
      setApt,
    };
  },
  {
    persist: {
      storage: piniaPluginPersistedstate.localStorage(),
    },
  },
);

export type User = { id?: string };

export type Device = { fingerprint?: string };

export type Utm = {
  source?: string;
  medium?: string;
  campaign?: string;
  id?: string;
  term?: string;
  content?: string;
};

export type GoogleAttribution = {
  gclid?: string;
  gbraid?: string;
  wbraid?: string;
};

export type FacebookAttribution = {
  fbclid?: string;
  fbc?: string;
  fbp?: string;
};

export type TiktokAttribution = {
  ttclid?: string;
};

export type AptAttribution = {
  channel?: string;
  content?: string;
  extra?: string;
};
